module.exports = __webpack_public_path__ + "img/level-2.acac7083.png";